module.exports = __webpack_public_path__ + "static/media/roadrate.0e508e1a.png";